export default __webpack_public_path__ + "static/media/person2@2x.38cf9c65.webp";